module.exports = __webpack_public_path__ + "img/drivers-license.a0840e8b.png";